/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UploadButton/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ImageIcon from 'DesignSystem/Svgs/ImageIcon/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function UploadButton({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Picture/Upload/UploadButton",
  isHovered
  
}) {
let dtUploadbuttonBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'UploadButton.backgroundColor.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.xs'
        })
let dtTypographyFontweightRegular = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.regular'
        })
  return (<React.Fragment
>
<div
  data-testid="UploadButton.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-2-Z2n7Wc3': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z2n7Wc3': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-Z2n7Wc3': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-5-Z2n7Wc3': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-Z2n7Wc3': isHovered ? "rgba(111,111,111, 0.1)" : dtUploadbuttonBackgroundcolorPrimaryBase}}
 className={`views-block ${styles.Horizontal}`}
>
<ImageIcon
  viewPath={`${viewPath}/ImageIcon`}
 height={14}
 width={14}
 stroke="white"
/>
<Label
  viewPath={`${viewPath}/Label`}
 text="Select an image"
 marginLeft={dtSpaceXs}
 color="white"
 marginBottom={0}
 marginTop={1}
 fontSize={dtTypographyFontsizeXs}
 fontWeight={dtTypographyFontweightRegular}
 textTransform="uppercase"
/>
</div>
{children}
</React.Fragment>)
}